<script setup lang="ts">
  import { computed } from 'vue';
  import { Pencil } from 'lucide-vue-next';

  const props = defineProps<{ changeCount: number }>();
  const emit = defineEmits<{ (e: 'exit'): void }>();

  const countLabel = computed(() => {
    if (props.changeCount === 0) return 'Nenhuma alteração ainda';
    return `${props.changeCount} ${props.changeCount === 1 ? 'alteração' : 'alterações'} para salvar`;
  });
</script>

<template>
  <div
    class="flex flex-wrap items-center gap-x-4 gap-y-2 text-[13px]/[18px] text-gray-03"
    data-testid="correction-mode-status"
  >
    <p
      class="flex min-w-0 flex-[1_1_320px] items-start gap-2.5"
      role="status"
    >
      <span
        class="-mt-0.5 flex size-5.5 shrink-0 items-center justify-center rounded-full bg-badge-info text-white-02"
        aria-hidden="true"
      >
        <Pencil
          class="size-3"
          :stroke-width="3"
        />
      </span>
      <span>
        <b class="font-semibold text-change-fixed-ink">Modo correção ligado.</b>
        Você pode alterar respostas já dadas; cada alteração fica registrada com o valor antigo.
      </span>
    </p>
    <div
      class="flex flex-wrap gap-x-3.5 gap-y-1 text-xs"
      aria-label="Legenda"
    >
      <span class="inline-flex items-center gap-1.5 whitespace-nowrap">
        <i class="size-3.5 shrink-0 rounded-[3px] border border-change-fixed-border bg-change-fixed" />
        Alterado
      </span>
      <span class="inline-flex items-center gap-1.5 whitespace-nowrap">
        <i class="size-3.5 shrink-0 rounded-[3px] border border-change-added-border bg-change-added" />
        Preenchido agora
      </span>
      <span
        class="whitespace-nowrap font-medium tabular-nums text-gray-07"
        data-testid="correction-mode-count"
      >
        {{ countLabel }}
      </span>
    </div>
    <button
      type="button"
      class="h-8 shrink-0 whitespace-nowrap rounded-lg border border-change-fixed-ink px-3 text-[13px] font-medium text-change-fixed-ink hover:bg-change-fixed focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-change-fixed-ink"
      data-testid="correction-mode-exit"
      @click="emit('exit')"
    >
      Sair do modo correção (<kbd class="font-[inherit] font-semibold">Ctrl+F8</kbd>)
    </button>
  </div>
</template>
